<template lang="html">
	<td
		class="om-table-cell"
		:class="{'om-table-cell-has-checkbox': hasCheckbox}"
		v-bind="$attrs"
		ref="cell"
	>
		<!-- @slot Cell Content -->
		<slot></slot>
	</td>
</template>

<script lang="js">
/**
 * Table Cell
 * @displayName Table Cell
 * @since 2.0.0
 */
export default  {
	props : {
		/**
		 * Whether this cell has the checkbox.
		 *
		 * @type {Boolean}
		 */
		hasCheckbox : Boolean,
	},
}

</script>

<style scoped lang="scss">
	.om-table-cell-has-checkbox {
		padding: 8px 10px;

		input[type="checkbox"] {
			margin: 0 0 0 8px;
		}
	}
</style>
